import { render, staticRenderFns } from "./file.vue?vue&type=template&id=6005620f&"
import script from "./file.ts?vue&type=script&lang=ts&"
export * from "./file.ts?vue&type=script&lang=ts&"
import style0 from "./file.scss?vue&type=style&index=0&lang=scss&_scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports